import {appsService} from "../services/appsService";
import {subscriptionManagerService} from "../services/subscriptionManagerService";
import Vue from 'vue'

const state = {
  apps: []
};

const getters = {
  apps: (state)  => state.apps,
  app: (state) => {
    return function (appCodeName) {
      return state.apps.find(a => a.app_code_name == appCodeName)
    }
  },
  appUsabilityStatus: (state, getters) => {
    return function (appCodeName, hasAppMarket) {
        let app = getters.app(appCodeName)
        if(!app) return {}
        let status = {
          requires_upgrade: false,
          requires_install: false,
          purchase_state: '',
          requires_purchase: false,
          is_usable: false
        }

        if (app.paid_data) {
          status.purchase_state = app.paid_data.purchase_state
          status.requires_purchase = app.paid_data.requires_purchase
        }
        if (app.requires_upgrade)
          status.requires_upgrade = true
        if (hasAppMarket && app.status != 'installed' && !app.built_in)
          status.requires_install = true
        if (!status.requires_upgrade && !status.requires_install && !status.requires_purchase)
          status.is_usable = true

        return status
    }
  }
};

const mutations = {
  setApps(state, filters) {
    state.apps = filters;
  },
  setApp(state, value) {
    if(value.app_code_name == "paypalwallet"){
      value.description.logo = "https://app0.vcdnita.com/vue/img/Paypal_venmo_full_sized_with_fixed_O.bd4ebfdd.svg";
    }

    for(let i = 0; i < state.apps.length; i++) {
      if (state.apps[i].app_code_name === value.app_code_name){
        Vue.set(state.apps, i, value)
        break
      }
    }
  },
  setPurchasedAppData(state, value) {
    let paid_data;
    const subscription = value.subscription
    const app_code_name = value.app_code_name
    const price_uid = value.price_uid

    for(let i = 0; i < state.apps.length; i++) {
      if (state.apps[i].app_code_name === app_code_name){
        paid_data = {
          price: subscription['purchase_price'],
          currency: subscription['purchase_currency'],
          purchase_state: subscription['purchase_state'],
          price_uid: price_uid,
          requires_purchase: false
        }
        Vue.set(state.apps, i, {...state.apps[i], paid_data: paid_data})
        break
      }
    }
  }
};

const actions = {
  async loadApps({commit, getters, state}, data) {
    if (getters.apps.length == 0 || data.force) {
      const result = await appsService.getApps();

      var paypalIndex = result.apps.map(function(app) { return app.app_code_name; }).indexOf('paypalwallet');
      if(paypalIndex != -1)
      {
        result.apps[paypalIndex].description.logo = "https://app0.vcdnita.com/vue/img/Paypal_venmo_full_sized_with_fixed_O.bd4ebfdd.svg";
      }
      const aggResult = data.isIOS ? await subscriptionManagerService.removePaidApps(result.apps, data.hasPaidApps) : await subscriptionManagerService.aggregateAppData(result.apps, data.hasPaidApps)
      commit('setApps', aggResult);
    }
  },
  async installApp({commit, getters, state}, params) {
    const result = await appsService.installApp(params);
    const appPaidData = getters.app(result.app_data.app_code_name).paid_data
    let app_data = result.app_data

    if (appPaidData) {
      app_data = {...result.app_data, paid_data: appPaidData}
    }

    commit('setApp', app_data);
  },
  async uninstallApp({commit, getters, state}, params) {
    const result = await appsService.uninstallApp(params);
    const appPaidData = getters.app(result.app_data.app_code_name).paid_data
    let app_data = result.app_data

    if (appPaidData) {
      let paid_data = {
        price: appPaidData.price,
        currency: appPaidData.currency,
        purchase_state: 'canceled',
        price_uid: appPaidData['price_uid'],
        requires_purchase: true
      }
      app_data = {...result.app_data, paid_data: paid_data}
    }

    commit('setApp', app_data);
  },
  async purchaseApp({commit, state}, params) {
    const result = await subscriptionManagerService.createSubscription(params.purchasable_data);

    commit('setPurchasedAppData', {
      app_code_name: params.app_code_name,
      price_uid: params.purchasable_data.subscription.purchasable_price_uid,
      subscription: result.subscription
    });
  },
  async logUpgradeButtonClicked({commit, state}, selectedApp) {
    await appsService.logUpgradeButtonClicked(selectedApp.app_code_name);
  },
  async initiateAppFlow({commit, dispatch, getters, rootGetters}, appCodeName) {
    await dispatch('loadApps', {})
    let hasAppMarket = rootGetters.hasFeature('app_market_available')
    let status = getters.appUsabilityStatus(appCodeName, hasAppMarket)

    if (hasAppMarket && (status.requires_upgrade || status.requires_install || status.requires_purchase))
      Vue.prototype.$frontageApi.send('open-app-info-page',{app_code_name: appCodeName})
    else if (!hasAppMarket && status.requires_upgrade)
      Vue.prototype.$frontageApi.send('open-upgrade-dialog')
  }
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
